import React from "react";
import Container from "@material-ui/core/Container";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import styles from "./ChooseLawyer.module.scss";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import SearchImage from "../../assets/img/search2.png";
import api from "../../services/Api";
import Header from "../Shared/Header/Header";
import SingleLawyer from "./SingleLawyer/SingleLawyer";
import Filters from "./Filters/Filters";
import FiltersIcon from "../../assets/img/filters.png";
import ContentBox from "../Shared/ContentBox/ContentBox";
import Loader from "../Shared/Loader/Loader";
import Footer from "../Shared/Footer/Footer";
import Scroll from "../../services/Scroll";
import DesktopMenu from "../Shared/DesktopMenu/DesktopMenu";
import OrderConsultation from "./OrderConsultation/OrderConsultation";

class ChooseLawyer extends React.Component<any, any> {
  constructor(props) {
    super(props);

    this.state = {
      lawyers: null,
      domain: this.props.match.params.domainId
        ? parseInt(this.props.match.params.domainId)
        : null,
      domainName: null,
      status: null,
      domains: null,
      boxContent: null,
      showBoxContent: false,
      boxContentTitle: null,
      boxContentSubTitle: null,
      boxContentStep: null,
      boxContentLawyerInfo: false,
      loaded: false,
      dateFrom: null,
      dateTo: null,
      currentLawyer: null,
      filterByDate: false,
      imageUrl: undefined,
    };
  }

  sortLawyers(a, b) {
    if (this.props.user.lawyers.includes(a.id)) {
      return 1;
    }

    return 0;
  }

  componentDidMount() {
    api
      .get("lawyers")
      .then((response) => {
        if (response.data.success) {
          let promises = [];

          let lawyersToShow = response.data.data.filter((lawyer) => {
            if (
              lawyer.description &&
              lawyer.education &&
              lawyer.imageId &&
              lawyer.isActive
            ) {
              return promises.push(
                api
                  .get("lawyers/" + lawyer.id + "/services")
                  .then((response) => {
                    const foundService = response.data.data.find(
                      (service) =>
                        service.Domain &&
                        service.Domain.id === this.state.domain
                    );
                    let price = null;
                    if (foundService) {
                      price = foundService.price;
                      lawyer.services = response.data.data;
                      lawyer.price = price;

                      return lawyer;
                    }
                  })
              );
            }
          });

          return Promise.all(promises).then(() => {
            this.setState({
              lawyers: lawyersToShow,
            });

            let promises2 = [];

            this.state.lawyers &&
              this.state.lawyers.map((lawyer) => {
                promises2.push(
                  api.get("/schedules/" + lawyer.id).then((response) => {
                    if (response.data.success) {
                      lawyer.schedule = response.data.data;
                    }
                  })
                );
              });

            return Promise.all(promises2).then(() => {
              this.setState({
                lawyers: this.state.lawyers,
              });
              this.setLoaded(true);
            });
          });
        }
      })
      .catch(() => {
        this.setLoaded(true);
      });

    api.get("domains/used").then((response) => {
      if (response.data.success) {
        this.setState({
          domains: response.data.data,
          domainName: this.state.domain
            ? response.data.data.find((e) => {
                return e.id == this.state.domain;
              }).name
            : null,
        });
      }
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    window.onpopstate = (e) => {
      this.setBoxContent(false);
    };
  }

  setLoaded = (value) => {
    this.setState({
      loaded: value,
    });
  };

  setDomainFilter = (domain, name) => {
    let splitedUrl = window.location.pathname.split("r/");
    window.history.pushState(
      {},
      "Wybierz prawnika - " + name,
      window.location.origin + splitedUrl[0] + "r/" + domain
    );

    this.componentDidMount();

    this.setState({
      domain: domain,
      domainName: name,
    });
    setTimeout(() => {
      document.getElementById("filterButton").click();
    }, 10); // Do poprawy, tymczasowe obejscie problemu.
  };

  setStatusFilter = (status) => {
    this.setState({
      status: status,
    });
    setTimeout(() => document.getElementById("filterButton").click(), 10); // Do poprawy, tymczasowe obejscie problemu.
  };

  setTextFilter = (e) => {
    this.setState({
      text: e.target.value,
    });
  };

  setDateFrom = (dateFrom) => {
    this.setState({
      dateFrom: dateFrom,
      filterByDate: true,
    });
  };

  setDateTo = (dateTo) => {
    this.setState({
      dateTo: dateTo,
      filterByDate: true,
    });
  };

  setCurrentLawyer = (lawyerId, imageUrl) => {
    this.setState({
      currentLawyer: lawyerId,
      imageUrl: imageUrl ? imageUrl : null,
    });
  };

  setSelectedDate = (from, to) => {
    this.setState({
      selectedTime: {
        start: from,
        end: to,
      },
    });
  };

  filteredLawyers = () => {
    if (!this.state.lawyers) return;
    var self = this;

    return this.state.lawyers
      .sort((a, b) => b.isFree - a.isFree)
      .filter((value) => {
        return this.state.domain
          ? value.domains.find((e) => e.id == self.state.domain)
          : value;
      })
      .filter((value) => {
        if (self.state.status) return value.lawyerStatus == self.state.status;
        else return value;
      })
      .filter(function (value) {
        if (self.state.text) {
          let allContent =
            value.name +
            " " +
            value.surname +
            value.description +
            value.education;
          return (
            allContent.toLowerCase().indexOf(self.state.text.toLowerCase()) > -1
          );
        } else return value;
      })
      .filter(function (value) {
        let match = false;
        if (self.state.filterByDate) {
          const { dateFrom, dateTo } = self.state;
          if (dateTo) dateTo.setHours(23, 59, 59);
          value.schedule.map((day) => {
            let date = new Date(day.start);

            if (
              (!dateFrom || date >= dateFrom) &&
              (!dateTo || date <= dateTo)
            ) {
              day.list.map((hour) => {
                if (hour.free) match = true;
              });
            }
          });

          if (match) return value;
        } else return value;
      })
      .map((lawyer) => {
        return (
          <SingleLawyer
            lawyer={lawyer}
            domain={this.state.domain}
            domainName={this.state.domainName}
            key={lawyer.id}
            setBoxContent={this.setBoxContent}
            setLoaded={this.setLoaded}
            currentLawyer={this.state.currentLawyer}
            setCurrentLawyer={this.setCurrentLawyer}
            setSelectedDate={this.setSelectedDate}
            currentUser={this.props.user}
          />
        );
      });
  };

  setBoxContent = (
    visable,
    content,
    title,
    subtitle,
    step,
    bottomContent,
    boxContentLawyerInfo
  ) => {
    if (step && this.state.step && this.state.step !== step) {
      Scroll.contentBoxToTop();
    }

    if (typeof visable === "number") {
      this.setState({
        boxContentStep: visable,
        boxContentSubTitle: content || this.state.boxContentSubTitle,
      });
      return;
    }

    if (visable === false) {
      this.setState({
        showBoxContent: false,
        boxContentStep: null,
        currentLawyer: null,
      });

      if (this.state.currentLawyer && this.state.selectedTime) {
        api
          .post("/reservedAppointments/delete", {
            lawyerId: this.state.currentLawyer,
            start: this.state.selectedTime["start"],
          })
          .then((response) => {
            if (response.data.success)
              this.setState({
                selectedTime: null,
              });
          });
      }

      return;
    }

    this.setState({
      showBoxContent: visable || false,
      boxContent: content || this.state.boxContent,
      boxContentTitle: title || this.state.title,
      boxContentSubTitle: subtitle || this.state.boxContentSubTitle,
      boxContentStep: step || null,
      bottomContent: bottomContent || null,
      boxContentLawyerInfo:
        boxContentLawyerInfo || boxContentLawyerInfo == undefined
          ? true
          : false,
    });

    if (!window.location.hash)
      window.history.pushState({}, "test", window.location.href + "#selected");
  };

  render() {
    const {
      domain,
      status,
      domains,
      domainName,
      showBoxContent,
      boxContentTitle,
      boxContentSubTitle,
      loaded,
      currentLawyer,
    } = this.state;

    return (
      <>
        <Header user={this.props.user} />

        <div id="pageContent">
          <DesktopMenu user={this.props.user} />
          <div id="leftSide" className="leftSide">
            <div className={styles.ChooseLawyer}>
              {/*<div className={styles.navigation}>*/}
              {/*    <Container maxWidth="md">*/}
              {/*        <Link to="/" className={styles.back}>*/}
              {/*            <Button*/}
              {/*                variant="outlined"*/}
              {/*                color="primary"*/}
              {/*                startIcon={<img src={ArrowL} alt="Arrow"/>}*/}
              {/*            >*/}
              {/*                Cofnij*/}
              {/*            </Button>*/}
              {/*        </Link>*/}
              {/*        <Button*/}
              {/*            variant="outlined"*/}
              {/*            color="primary"*/}
              {/*            startIcon={<img src={FiltersIcon} alt="Filters"/>}*/}
              {/*            onClick={()=>this.setBoxContent(*/}
              {/*                true,*/}
              {/*                <Filters*/}
              {/*                    setDomainFilter={this.setDomainFilter}*/}
              {/*                    setStatusFilter={this.setStatusFilter}*/}
              {/*                    currentDomain={domain}*/}
              {/*                    currentStatus={status}*/}
              {/*                    domains={domains}*/}
              {/*                    setBoxContent={this.setBoxContent}*/}
              {/*                />,*/}
              {/*                'Filtry'*/}
              {/*            )}*/}
              {/*            id="filterButton"*/}
              {/*        >*/}
              {/*            Filtry*/}
              {/*        </Button>*/}
              {/*    </Container>*/}
              {/*</div>*/}
              <div className={styles.page_header}>
                <Container maxWidth="md" id="hLawyers">
                  <div className={styles.subtitle}>{domainName}</div>
                  <h2>
                    <strong>Wybierz prawnika</strong>
                    <br /> i umów konsultację
                  </h2>
                  <div
                    className={styles.searchAndFilters}
                    id="searchAndFilters"
                  >
                    <TextField
                      label="Szukaj"
                      variant="outlined"
                      color="primary"
                      size="small"
                      className={styles.searchInput}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="Search"
                              className={styles.expand}
                            >
                              <img src={SearchImage} alt="Search" />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      onChange={this.setTextFilter}
                      InputLabelProps={{
                        classes: {
                          root: styles.root,
                          shrink: styles.shrink,
                        },
                      }}
                    />
                    <Button
                      variant="outlined"
                      color="primary"
                      startIcon={<img src={FiltersIcon} alt="Filters" />}
                      onClick={() =>
                        this.setBoxContent(
                          true,
                          <Filters
                            setDomainFilter={this.setDomainFilter}
                            setStatusFilter={this.setStatusFilter}
                            setDateFrom={this.setDateFrom}
                            setDateTo={this.setDateTo}
                            currentDomain={domain}
                            currentStatus={status}
                            domains={domains}
                            setBoxContent={this.setBoxContent}
                          />,
                          "Filtry",
                          " ",
                          false,
                          false,
                          false
                        )
                      }
                      className={styles.filterButton}
                      id="filterButton"
                    >
                      Filtry
                    </Button>
                  </div>
                </Container>
              </div>
              <Container maxWidth="md" id="lawyersContainer">
                <div>
                  {loaded ? (
                    loaded === true &&
                    this.filteredLawyers() &&
                    this.filteredLawyers().length ? (
                      this.filteredLawyers()
                    ) : (
                      <div>Brak pasujących wyników.</div>
                    )
                  ) : (
                    <Loader />
                  )}
                </div>
              </Container>
            </div>
            <Footer />
          </div>
          {/*{showBoxContent &&*/}
          <ContentBox
            isOpen={showBoxContent}
            setBoxContent={this.setBoxContent}
            title={boxContentTitle}
            subtitle={boxContentSubTitle}
            step={this.state.boxContentStep}
            maxStep={this.props.user ? 2 : 3}
            className={styles.contetnBox}
            bottomContent={this.state.bottomContent}
            currentLawyer={currentLawyer}
            changeBody={false}
            boxContentLawyerInfo={this.state.boxContentLawyerInfo}
            imageUrl={this.state.imageUrl}
          >
            {this.state.boxContent}
          </ContentBox>
          {/*}*/}
        </div>
      </>
    );
  }
}

ChooseLawyer.defaultProps = {};

export default ChooseLawyer;
